<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div id="customerHub">
      <div fxLayout="row wrap" fxLayoutGap="20px grid">
        <div fxFlex="100" fxFlex.gt-sm="100">
          <mat-card class="u-margin-bottom-15" style="padding: 25px;">
            <mat-card-content
              *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketCustomerHubProviderDetails')['controls']; let i = index"
              formArrayName="ebasketCustomerHubProviderDetails"
            >
              <div [formGroupName]="i" fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="80">
                  <div fxFlex="100" fxFlex.gt-sm="30">
                    <mat-label style="text-align: left;"
                      >{{"module-assignment.customerHub.provider" | translate }}<span
                        class="required-astrik"
                        >*</span
                      ></mat-label
                    >
                    <mat-form-field id="matFrmFieldProvider" style="padding-left: 20pt;">
                      <mat-label
                        >{{"module-assignment.customerHub.please_select" | translate }}</mat-label
                      >
                      <mat-select
                        (selectionChange)="changeEbasketCustomerHubProvider($event.value,i)"
                        id="matSelectProvider"
                        formControlName="customerHubProviderControl"
                      >
                        <mat-option
                          *ngFor="let provider of customerHubProviderOptions[i]"
                          [value]="provider.value"
                        >
                          {{ provider.name }}
                        </mat-option>
                      </mat-select>
                      <!-- <mat-error *ngIf="customerHubProviderControl.hasError('required')"
                          >Please Select Any One
                        </mat-error> -->
                    </mat-form-field>
                  </div>
                </div>
                <div fxFlex="20" class="u-text-right">
                  <button
                    style="background-color: transparent;
                    color: #000000;"
                    [disabled]="action=='view'"
                    mat-flat-button
                    color="primary"
                    (click)="deleteCustomerHubProviderDetailContainer(i);"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>

                <div fxFlex="100" fxFlex.gt-sm="100">
                  <!-- NETSUITE PROVIDER IMPLEMENTATION -->
                  <div *ngIf="enableCustomerHubNetSuiteDetails[i]">
                    <netsuite-customer-hub-details-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubDetails]="customerHubNetsuiteAuthDetails"
                      [authControlKey]="'customerHubNetsuiteAuthenticationKey'"
                    >
                    </netsuite-customer-hub-details-settings>
                    <customer-hub-import-export-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubImportExportDetails]="customerHubNetsuiteAuthDetails"
                      [authControlKey]="'customerHubNetsuiteImportExportKey'"
                    >
                    </customer-hub-import-export-settings>
                  </div>
                  <!-- MAJOREL PROVIDER IMPLEMENTATION -->
                  <div *ngIf="enableCustomerHubMajorelDetails[i]">
                    <majorel-customer-hub-details-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubDetails]="customerHubMajorelAuthDetails"
                      [authControlKey]="'customerHubMajorelAuthenticationKey'"
                    >
                    </majorel-customer-hub-details-settings>
                    <customer-hub-import-export-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubImportExportDetails]="customerHubMajorelAuthDetails"
                      [authControlKey]="'customerHubMajorelImportExportKey'"
                    >
                    </customer-hub-import-export-settings>
                  </div>
                  <!-- XIATECH PROVIDER IMPLEMENTATION -->
                  <div *ngIf="enableCustomerHubXiatechDetails[i]">
                    <xiatech-customer-hub-details-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubDetails]="customerHubXiatechAuthDetails"
                      [authControlKey]="'customerHubXiatechAuthenticationKey'"
                    >
                    </xiatech-customer-hub-details-settings>
                    <customer-hub-import-export-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubImportExportDetails]="customerHubXiatechAuthDetails"
                      [authControlKey]="'customerHubXiatechImportExportKey'"
                    >
                    </customer-hub-import-export-settings>
                  </div>
                  <!-- RJ PROVIDER IMPLEMENTATION -->
                  <div *ngIf="enableCustomerHubRJDetails[i]">
                    <customer-hub-import-export-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubImportExportDetails]="customerHubRJAuthDetails"
                      [authControlKey]="'customerHubRJImportExportKey'"
                    >
                    </customer-hub-import-export-settings>
                  </div>
                  <!-- AX PROVIDER IMPLEMENTATION -->
                  <div *ngIf="enableCustomerHubAXDetails[i]">
                    <ax-configDetails-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubDetails]="customerHubAXAuthDetails"
                      [authControlKey]="'customerHubAxAuthenticationKey'"
                    >
                    </ax-configDetails-settings>
                    <customer-hub-import-export-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubImportExportDetails]="customerHubAXAuthDetails"
                      [authControlKey]="'customerHubAXImportExportKey'"
                    >
                    </customer-hub-import-export-settings>
                  </div>
                  <!-- GRAPHENE PROVIDER IMPLEMENTATION -->
                  <div *ngIf="enableCustomerHubGrapheneDetails[i]">
                    <customer-hub-import-export-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubImportExportDetails]="customerHubGrapheneAuthDetails"
                      [authControlKey]="'customerHubGrapheneImportExportKey'"
                    >
                    </customer-hub-import-export-settings>
                  </div>
                  <!-- IEW PROVIDER IMPLEMENTATION -->
                  <div *ngIf="enableCustomerHubIEWDetails[i]">
                    <customer-hub-import-export-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubImportExportDetails]="customerHubIEWAuthDetails"
                      [authControlKey]="'customerHubIEWImportExportKey'"
                    >
                    </customer-hub-import-export-settings>
                  </div>
                  <!-- CREST-ENGAGEMENT PROVIDER IMPLEMENTATION -->
                  <div *ngIf="enableCustomerHubCrestEngagementDetails[i]">
                    <customer-hub-import-export-settings
                      [action]="action"
                      [parentForm]="parentForm.get(authControlKey)"
                      [customerHubImportExportDetails]="customerHubCrestEngagementAuthDetails"
                      [authControlKey]="'customerHubCrestEngagementImportExportKey'"
                    >
                    </customer-hub-import-export-settings>
                  </div>
                </div>
              </div>
            </mat-card-content>
            <mat-card-header>
              <div fxFlex="20" class="u-text-left">
                <mat-card-title>
                  {{ "organization.create.section_4.add_provider" | translate }}</mat-card-title
                >
              </div>
              <div fxFlex="80" class="u-text-right">
                <button
                  style="background-color: transparent;
                    color: #000000;"
                  [disabled]="action=='view' || enableDisableAddProviders() || isProviderSelected()"
                  mat-flat-button
                  color="primary"
                  (click)="openCustomerHubSelectProviderPopup();"
                >
                  <mat-icon>add_circle_outline</mat-icon>
                  <!-- {{ 'organization.module_assignment_tab.reason_code_tab.add' | translate}} -->
                </button>
              </div>
            </mat-card-header>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
        <p style="text-indent: 30pt;">{{"module-assignment.customerHub.woosmap" | translate }}</p>
        <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-15">
          <mat-slide-toggle
            id="matSelectTogglewooseMap"
            formControlName="woosemap"
            (change)="toggleWooseMap()"
          >
          </mat-slide-toggle>
        </div>
      </div>
      <div id="woosemap" *ngIf="!isToggleWooseMap">
        <div fxLayout="row wrap" fxLayoutGap="2px grid">
          <div fxFlex="100" fxFlex.gt-sm="40">
            <mat-label style=" text-align: left; padding-left: 45pt;"
              >{{"module-assignment.customerHub.private_key" | translate }}</mat-label
            >
            <mat-form-field id="matFrmFieldprivateKey" style="padding-left: 60pt;">
              <input
                id="txtSubDomain"
                matInput
                formControlName="privateKey"
                maxlength="500"
                [placeholder]="'module-assignment.customerHub.private_key' | translate"
              />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="2px grid">
          <div fxFlex="100" fxFlex.gt-sm="40">
            <mat-label style="text-align: left; padding-left: 60pt;"
              >{{"module-assignment.customerHub.country" | translate }}</mat-label
            >
            <mat-form-field id="matFrmFieldCountry" style="padding-left: 60pt;">
              <mat-select
                id="matSelectCountryCode"
                formControlName="countries"
                [placeholder]="'organization.create.country_code' | translate"
                [multiple]="true"
              >
                <app-mat-select-search
                  id="matSelectSearchCountries"
                  formControlName="countriesMultiFilterCtrl"
                >
                </app-mat-select-search>
                <mat-option
                  *ngFor="let country of filteredCountries | async"
                  [value]="country.country_code"
                >
                  {{ country.name + ' (' + country.country_code + ')'}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <!-- <mat-form-field id="matFrmFieldcountry" style="padding-left: 60pt;">
                <input id="txtSubDomain" matInput formControlName="country" maxlength="30" />
              </mat-form-field> -->
          </div>
        </div>
      </div>
      <!-- customer scanning toggle -->
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
        <p style="text-indent: 30pt;">
          {{"module-assignment.customerHub.link_customer_by_scanning" | translate }}
        </p>
        <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-15">
          <mat-slide-toggle
            id="matSelectToggleCustomerByScanning"
            formControlName="linkCustomerByScanning"
            (change)="toggleLinkCustomerByScanning()"
          >
          </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="10px grid" class="u-margin-top-10">
        <p style="text-indent: 30pt;">
          {{"module-assignment.customerHub.add_customer" | translate }}
        </p>

        <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-12">
          <mat-slide-toggle
            id="matSelectToggleaddCustomer"
            formControlName="addCustomer"
            (change)="toggleAddCustomer()"
          >
          </mat-slide-toggle>
        </div>
      </div>
      <div id="addCustomer" *ngIf="!isToggleAddCustomer">
        <div fxLayout="row wrap" fxLayoutGap="20px grid">
          <div fxFlex="100" fxFlex.gt-sm="40">
            <mat-label style="text-align: left; padding-left: 60pt;"
              >{{"module-assignment.customerHub.basket_screen" | translate }}</mat-label
            >
            <mat-checkbox
              style="padding-left: 30pt;"
              id="matCheckboxExport"
              formControlName="basketScreen"
              placeholder="Sales Export"
              checked="isToggleAddCustomer"
            >
            </mat-checkbox>
          </div>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-5">
          <div fxFlex="100" fxFlex.gt-sm="40">
            <mat-label style="text-align: left; padding-left: 60pt;"
              >{{"module-assignment.customerHub.payment_screen" | translate }}</mat-label
            >
            <mat-checkbox
              style="padding-left: 20pt;"
              id="matCheckboxrt"
              formControlName="paymentScreen"
              placeholder="Sales Export"
              checked="isToggleAddCustomer"
            >
            </mat-checkbox>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
          <div fxFlex="100">
            <mat-card class="u-margin-bottom-15">
              <mat-card-content>
                <div fxFlex="100">
                  <mat-accordion>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          {{
                          "organization.create.section_4.customer_hub_section_1.additional_customer_info"
                          | translate }}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div fxLayout="row wrap" fxLayoutGap="20px grid">
                        <div fxFlex="33">
                          <mat-slide-toggle id="matSelectToggleName" formControlName="name">
                            {{ "organization.create.section_4.customer_hub_section_1.name" |
                            translate }}
                          </mat-slide-toggle>
                        </div>
                        <div fxFlex="33">
                          <mat-slide-toggle
                            id="matSelectToggleDateOfBirth"
                            formControlName="dateOfBirth"
                          >
                            {{ "organization.create.section_4.customer_hub_section_1.date_of_birth"
                            | translate }}
                          </mat-slide-toggle>
                        </div>
                        <div fxFlex="33">
                          <mat-slide-toggle id="matSelectToggleEmail" formControlName="email">
                            {{ "organization.create.section_4.customer_hub_section_1.email" |
                            translate }}
                          </mat-slide-toggle>
                        </div>
                      </div>
                      <div fxLayout="row wrap" fxLayoutGap="20px grid">
                        <div fxFlex="33">
                          <mat-slide-toggle
                            id="matSelectToggleCustomerMobileNumber"
                            formControlName="customerMobileNumber"
                          >
                            {{
                            "organization.create.section_4.customer_hub_section_1.customer_mobile_number"
                            | translate }}
                          </mat-slide-toggle>
                        </div>
                        <div fxFlex="33">
                          <mat-slide-toggle
                            id="matSelectToggleAddressLine1And2"
                            formControlName="customerAddressLine"
                          >
                            {{
                            "organization.create.section_4.customer_hub_section_1.address_line_1_and_2"
                            | translate }}
                          </mat-slide-toggle>
                        </div>
                        <div fxFlex="33">
                          <mat-slide-toggle id="matSelectToggleCity" formControlName="customerCity">
                            {{ "organization.create.section_4.customer_hub_section_1.city" |
                            translate }}
                          </mat-slide-toggle>
                        </div>
                      </div>
                      <div fxLayout="row wrap" fxLayoutGap="20px grid">
                        <div fxFlex="33">
                          <mat-slide-toggle
                            id="matSelectToggleRegion"
                            formControlName="customerRegion"
                          >
                            {{ "organization.create.section_4.customer_hub_section_1.Region" |
                            translate }}
                          </mat-slide-toggle>
                        </div>
                        <div fxFlex="33">
                          <mat-slide-toggle
                            id="matSelectToggleCountry"
                            formControlName="customerCountry"
                          >
                            {{ "organization.create.section_4.customer_hub_section_1.Country" |
                            translate }}
                          </mat-slide-toggle>
                        </div>
                        <div fxFlex="33">
                          <mat-slide-toggle
                            id="matSelectTogglePostCode"
                            formControlName="customerPostCode"
                          >
                            {{ "organization.create.section_4.customer_hub_section_1.Postcode" |
                            translate }}
                          </mat-slide-toggle>
                        </div>
                      </div>
                      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
                        <div fxFlex="100">
                          <mat-slide-toggle
                            (change)="toggleMarketingPreference()"
                            id="matSelectToggleMarketingPreference"
                            formControlName="customerMarketingPreference"
                          >
                            {{
                            "organization.create.section_4.customer_hub_section_1.marketing_preference"
                            | translate }}
                          </mat-slide-toggle>
                        </div>
                      </div>
                      <div *ngIf="isToggleMarketingPreference">
                        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-left-45">
                          <div fxFlex="33">
                            <mat-checkbox checked formControlName="email_marketing">
                              {{
                              "organization.create.section_4.customer_hub_section_1.email_marketing"
                              | translate }}
                            </mat-checkbox>
                          </div>
                          <div fxFlex="33">
                            <mat-checkbox checked formControlName="text_marketing">
                              {{
                              "organization.create.section_4.customer_hub_section_1.text_marketing"
                              | translate }}
                            </mat-checkbox>
                          </div>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-left-45">
                          <div fxFlex="33">
                            <mat-checkbox checked formControlName="catalogue_by_post">
                              {{
                              "organization.create.section_4.customer_hub_section_1.catalogue_by_post"
                              | translate }}
                            </mat-checkbox>
                          </div>
                          <div fxFlex="33">
                            <mat-checkbox checked formControlName="third_party_mailing">
                              {{
                              "organization.create.section_4.customer_hub_section_1.third_party_mailing"
                              | translate }}
                            </mat-checkbox>
                          </div>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-left-45">
                          <div fxFlex="33">
                            <mat-checkbox checked formControlName="phone_marketing">
                              {{
                              "organization.create.section_4.customer_hub_section_1.phone_marketing"
                              | translate }}
                            </mat-checkbox>
                          </div>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="10px grid" class="u-margin-top-10">
        <p style="text-indent: 30pt;">
          {{"module-assignment.customerHub.default_customer" | translate }}
        </p>

        <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-12">
          <mat-slide-toggle
            id="matSelectToggleDefaultCustomer"
            formControlName="isDefaultCustomer"
            (change)="toggleDefaultCustomer()"
          >
          </mat-slide-toggle>
        </div>
      </div>
      <div id="defaultCustomer" *ngIf="isToggleDefaultCustomer">
        <div
          fxLayout="row wrap"
          *ngIf="parentForm?.get(authControlKey)?.get('defaultCustomer')!=null"
          fxLayoutGap="20px grid"
          class="u-margin-top-10"
        >
          <div fxFlex="100" formGroupName="defaultCustomer">
            <mat-card class="u-margin-bottom-15">
              <mat-card-content>
                <div fxFlex="100">
                  <mat-accordion>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <b>{{"module-assignment.customerHub.add_customer" | translate }}</b>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div fxLayout="row wrap">
                        <div fxFlex="100">
                          <div fxLayout="row wrap" fxLayoutGap="grid">
                            <div
                              fxFlex="100"
                              class="u-text-right u-margin-top-12 u-margin-bottom-12 u-padding-right-6"
                            >
                              <mat-checkbox class="mat-block" formControlName="allowEditCustomer">
                                {{"module-assignment.customerHub.allow_edit_customer" | translate }}
                              </mat-checkbox>
                            </div>
                          </div>

                          <div fxLayout="row wrap" formGroupName="person" fxLayoutGap="20px grid">
                            <div fxFlex="33">
                              <mat-form-field class="mat-block">
                                <input
                                  matInput
                                  formControlName="title"
                                  [placeholder]="'module-assignment.customerHub.title' | translate"
                                />
                                <mat-error class="error-message">
                                  <span
                                    *ngIf="dc.get('defaultCustomer.person.title').hasError('required')"
                                  >
                                    {{"module-assignment.customerHub.validation.please_enter_valid_title"
                                    | translate }}
                                  </span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                            <div fxFlex="33">
                              <mat-form-field class="mat-block">
                                <input
                                  matInput
                                  [required]="isRequired('defaultCustomer.person.firstName')"
                                  formControlName="firstName"
                                  [placeholder]="'module-assignment.customerHub.first_name' | translate"
                                />
                                <mat-error class="error-message">
                                  <span
                                    *ngIf="dc.get('defaultCustomer.person.firstName').hasError('required')"
                                  >
                                    {{"module-assignment.customerHub.validation.first_name_is_mandatory"
                                    | translate }}
                                  </span>
                                </mat-error>
                                <mat-error class="error-message">
                                  <span
                                    *ngIf="(dc.get('defaultCustomer.person.firstName').touched) && dc.get('defaultCustomer.person.firstName').hasError('maxlength')"
                                  >
                                    {{ "organization.create.validations.firstName_size" | translate
                                    }}
                                  </span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                            <div fxFlex="33">
                              <mat-form-field class="mat-block">
                                <input
                                  matInput
                                  [required]="isRequired('defaultCustomer.person.lastName')"
                                  formControlName="lastName"
                                  [placeholder]="'module-assignment.customerHub.last_name' | translate"
                                />
                                <mat-error class="error-message">
                                  <span
                                    *ngIf="dc.get('defaultCustomer.person.lastName').hasError('required')"
                                  >
                                    {{"module-assignment.customerHub.validation.last_name_is_mandatory"
                                    | translate }}
                                  </span>
                                </mat-error>
                                <mat-error class="error-message">
                                  <span
                                    *ngIf="(dc.get('defaultCustomer.person.lastName').touched) && dc.get('defaultCustomer.person.lastName').hasError('maxlength')"
                                  >
                                    {{ "organization.create.validations.lastName_size" | translate
                                    }}
                                  </span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <div fxLayout="row wrap" fxLayoutGap="20px grid">
                            <div fxFlex="33">
                              <mat-form-field class="mat-block">
                                <input
                                  matInput
                                  [required]="isRequired('defaultCustomer.telephone')"
                                  formControlName="telephone"
                                  [placeholder]="'module-assignment.customerHub.phone_number' | translate"
                                />
                                <mat-error class="error-message">
                                  <span
                                    *ngIf="dc.get('defaultCustomer.telephone').hasError('required')"
                                  >
                                    {{"module-assignment.customerHub.validation.phone_number_is_mandatory"
                                    | translate }}
                                  </span>
                                  <span
                                    *ngIf="!dc.get('defaultCustomer.telephone').hasError('required')"
                                  >
                                    {{"module-assignment.customerHub.validation.please_enter_valid_phone_number"
                                    | translate }}
                                  </span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                            <div fxFlex="33">
                              <mat-form-field class="mat-block">
                                <input
                                  matInput
                                  [required]="isRequired('defaultCustomer.email')"
                                  formControlName="email"
                                  [placeholder]="'module-assignment.customerHub.email' | translate"
                                />
                                <mat-error class="error-message">
                                  <span
                                    *ngIf="dc.get('defaultCustomer.email').hasError('required')"
                                  >
                                    {{"module-assignment.customerHub.validation.email_is_mandatory"
                                    | translate }}
                                  </span>
                                  <span
                                    *ngIf="!dc.get('defaultCustomer.email').hasError('required')"
                                  >
                                    {{"module-assignment.customerHub.validation.please_enter_valid_email_address"
                                    | translate }}
                                  </span>
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>

                          <ng-container formGroupName="addressDetail">
                            <div fxLayout="row wrap" fxLayoutGap="20px grid">
                              <div fxFlex="66">
                                <mat-form-field class="mat-block">
                                  <input
                                    matInput
                                    formControlName="addressLine1"
                                    [placeholder]="'module-assignment.customerHub.address_line1' | translate"
                                  />
                                  <mat-error class="error-message">
                                    <span
                                      *ngIf="dc.get('defaultCustomer.addressDetail.addressLine1').hasError('required')"
                                    >
                                      {{"module-assignment.customerHub.validation.address_is_mandatory"
                                      | translate }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div fxFlex="66">
                                <mat-form-field class="mat-block">
                                  <input
                                    matInput
                                    [required]="isRequired('defaultCustomer.person.addressLine2')"
                                    formControlName="addressLine2"
                                    [placeholder]="'module-assignment.customerHub.address_line2' | translate"
                                  />
                                  <mat-error class="error-message"> </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                            <div fxLayout="row wrap" fxLayoutGap="20px grid">
                              <div fxFlex="25">
                                <mat-form-field class="mat-block">
                                  <input
                                    matInput
                                    [required]="isRequired('defaultCustomer.addressDetail.addressRegion')"
                                    formControlName="addressRegion"
                                    [placeholder]="'module-assignment.customerHub.region' | translate"
                                  />
                                  <mat-error class="error-message">
                                    <span
                                      *ngIf="dc.get('defaultCustomer.addressDetail.addressRegion').hasError('required')"
                                    >
                                      {{"module-assignment.customerHub.validation.region_is_mandatory"
                                      | translate }}
                                    </span>
                                    <span
                                      *ngIf="!dc.get('defaultCustomer.addressDetail.addressRegion').hasError('required')"
                                    >
                                      {{"module-assignment.customerHub.validation.please_enter_valid_region"
                                      | translate }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div fxFlex="25">
                                <mat-form-field class="mat-block">
                                  <input
                                    matInput
                                    [required]="isRequired('defaultCustomer.addressDetail.addressCountry')"
                                    formControlName="addressCountry"
                                    [placeholder]="'module-assignment.customerHub.country' | translate"
                                  />
                                  <mat-error class="error-message">
                                    <span
                                      *ngIf="dc.get('defaultCustomer.addressDetail.addressCountry').hasError('required')"
                                    >
                                      {{"module-assignment.customerHub.validation.country_is_mandatory"
                                      | translate }}
                                    </span>
                                    <span
                                      *ngIf="!dc.get('defaultCustomer.addressDetail.addressCountry').hasError('required')"
                                    >
                                      {{"module-assignment.customerHub.validation.please_enter_valid_country"
                                      | translate }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div fxFlex="25">
                                <mat-form-field class="mat-block">
                                  <input
                                    matInput
                                    [required]="isRequired('defaultCustomer.addressDetail.addressCity')"
                                    formControlName="addressCity"
                                    [placeholder]="'module-assignment.customerHub.city' | translate"
                                  />
                                  <mat-error class="error-message">
                                    <span
                                      *ngIf="dc.get('defaultCustomer.addressDetail.addressCity').hasError('required')"
                                    >
                                      {{"module-assignment.customerHub.validation.city_is_mandatory"
                                      | translate }}
                                    </span>
                                    <span
                                      *ngIf="!dc.get('defaultCustomer.addressDetail.addressCity').hasError('required')"
                                    >
                                      {{ "organization.create.validations.city_size" | translate }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div fxFlex="25">
                                <mat-form-field class="mat-block">
                                  <input
                                    matInput
                                    [required]="isRequired('defaultCustomer.addressDetail.postalCode')"
                                    formControlName="postalCode"
                                    [placeholder]="'module-assignment.customerHub.post_code' | translate"
                                  />
                                  <mat-error
                                    *ngIf="dc.get('defaultCustomer.addressDetail.postalCode').invalid"
                                    class="error-message"
                                  >
                                    <span
                                      *ngIf="dc.get('defaultCustomer.addressDetail.postalCode').hasError('required')"
                                    >
                                      {{"module-assignment.customerHub.validation.post_code_is_mandatory"
                                      | translate }}
                                    </span>
                                    <span
                                      *ngIf="!dc.get('defaultCustomer.addressDetail.postalCode').hasError('required')"
                                    >
                                      {{"module-assignment.customerHub.validation.please_enter_valid_post_code"
                                      | translate }}
                                    </span>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                        <div fxFlex="100">
                          <h4>
                            {{"module-assignment.customerHub.marketing_preferences" | translate }}
                          </h4>
                          <div
                            formGroupName="marketingPreference"
                            fxLayout="row wrap"
                            class="u-margin-top-10 u-margin-bottom-10"
                            fxLayoutGap="20px grid"
                          >
                            <div fxFlex="33">
                              <mat-checkbox class="mat-block" formControlName="emailMarketing">
                                {{"module-assignment.customerHub.email_marketing" | translate }}
                              </mat-checkbox>
                            </div>
                            <div fxFlex="33">
                              <mat-checkbox class="mat-block" formControlName="textMarketing">
                                {{"module-assignment.customerHub.text_marketing" | translate }}
                              </mat-checkbox>
                            </div>
                            <div fxFlex="33">
                              <mat-checkbox class="mat-block" formControlName="phoneMarketing">
                                {{"module-assignment.customerHub.phone_marketing" | translate }}
                              </mat-checkbox>
                            </div>
                            <div fxFlex="33">
                              <mat-checkbox class="mat-block" formControlName="catalogueByPost">
                                {{"module-assignment.customerHub.catelogue_by_post" | translate }}
                              </mat-checkbox>
                            </div>
                            <div fxFlex="33">
                              <mat-checkbox class="mat-block" formControlName="thirdPartyMailing">
                                {{"module-assignment.customerHub.third_party_mailing" | translate }}
                              </mat-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </mat-card-content>
              <mat-error
                *ngIf="dc.get('defaultCustomer.person.firstName').hasError('required') || dc.get('defaultCustomer.person.lastName').hasError('required') || dc.get('defaultCustomer.telephone').hasError('required') || dc.get('defaultCustomer.email').hasError('required') || dc.get('defaultCustomer.addressDetail.addressLine1').hasError('required') || dc.get('defaultCustomer.addressDetail.addressRegion').hasError('required') || dc.get('defaultCustomer.addressDetail.addressCountry').hasError('required') || dc.get('defaultCustomer.addressDetail.addressCity').hasError('required') || dc.get('defaultCustomer.addressDetail.postalCode').hasError('required')"
              >
                {{ "organization.create.validations.customer_details_required" | translate }}
              </mat-error>
            </mat-card>
          </div>
        </div>
      </div>

      <div fxLayout="row wrap" fxLayoutGap="10px grid" class="u-margin-top-10">
        <p style="text-indent: 30pt;">
          {{"module-assignment.customerHub.customer_support" | translate }}
        </p>
        <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-12">
          <mat-slide-toggle
            id="matSelectTogglecustomerSupport"
            formControlName="customerSupport"
            (change)="toggleCustomerSupport()"
          >
          </mat-slide-toggle>
        </div>
      </div>

      <div id="customerSupport" *ngIf="!isToggleCustomerSupport">
        <div fxLayout="row wrap">
          <div fxFlex="100" fxFlex.gt-sm="80">
            <mat-label style="text-align: left; padding-left: 60pt;"
              >{{"module-assignment.customerHub.customer_support_email" | translate }}</mat-label
            >
            <mat-form-field id="matFrmFieldCustomerSupportEmail" style="padding-left: 40pt;">
              <input
                id="txtCustomerSupportEmail"
                matInput
                formControlName="customerSupportEmail"
                maxlength="50"
                [placeholder]="'module-assignment.customerHub.customer_support_email'
              | translate"
              />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div fxLayout="row wrap" fxLayoutGap="10px grid" class="u-margin-top-10">
        <p style="text-indent: 30pt;">
          {{"module-assignment.customerHub.customer_iD_prefix" | translate }}
        </p>
        <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-12">
          <mat-form-field id="matFrmFieldcustIdPrefix">
            <input
              id="custIdPrefix"
              matInput
              (keyup)="onInputChange($event)"
              formControlName="custIdPrefix"
            />
            <mat-error
              id="matDiscountValueNanLimitExceed"
              class="error-message"
              *ngIf="parentForm.get(authControlKey).get('custIdPrefix').hasError('pattern')"
            >
              {{"module-assignment.customerHub.alphanumeric_validation" | translate }}
            </mat-error>
            <mat-error
              id="matDiscountValueNanLimitExceed"
              class="error-message"
              *ngIf="parentForm.get(authControlKey).get('custIdPrefix').hasError('maxlength')"
            >
              {{"module-assignment.customerHub.lenght_validation" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap" fxLayoutGap="10px grid" class="u-margin-top-10">
        <p style="text-indent: 30pt;">
          {{"module-assignment.customerHub.customer_id_sequence" | translate }}
        </p>
        <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-12">
          <mat-form-field id="matFrmFieldcustIdSequenceStartNu">
            <input id="custIdSequenceStartNu" matInput formControlName="custIdSequenceStartNu" />
            <mat-error
              id="matDiscountValueNanLimitExceed"
              class="error-message"
              *ngIf="parentForm.get(authControlKey).get('custIdSequenceStartNu').hasError('pattern')"
            >
              {{"module-assignment.customerHub.number_validation" | translate }}
            </mat-error>
            <mat-error
              id="matSquenceLimitExceed"
              class="error-message"
              *ngIf="parentForm.get(authControlKey).get('custIdSequenceStartNu').hasError('maxlength')"
            >
              {{"module-assignment.customerHub.squence_id_length_validation" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="action == 'edit'" style="padding-top: 15px;">
        <span>
          <p>
            <b>Note:Changing the customer prefix and sequence number may impact the customer ID.</b>
          </p>
        </span>
      </div>
      <div fxLayout="row">
        <div fxFlex="100" style="text-align: left;"></div>
      </div>
    </div>
  </div>
</div>
